import createReactComponent from '../createReactComponent';
export default createReactComponent('badge-tm', 'IconBadgeTm', [
  [
    'path',
    {
      d: 'M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M6 9h4', key: 'svg-1' }],
  ['path', { d: 'M8 9v6', key: 'svg-2' }],
  ['path', { d: 'M13 15v-6l2 3l2 -3v6', key: 'svg-3' }],
]);
